module.exports = __webpack_public_path__ + "static/media/Add.15b6531a.svg";